import { render, staticRenderFns } from "./Elections.vue?vue&type=template&id=dc5a1882"
import script from "./Elections.vue?vue&type=script&lang=js"
export * from "./Elections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports